import { useMemo } from 'react';
import { SearchRequiredState } from '../components/app/components/SourceConfigWrapper';
import { useFlowState } from '@getvim/flow-context-provider/build';
import { useOrderAssistAppFeatureFlags } from '../components/app/components/order-assist-app/OrderAssistFFWrapper';

export const useDatasourceLogo = (source: string | undefined): string | undefined => {
  const { datasourcesConfig } = useFlowState<SearchRequiredState>();
  const { shouldUseDatasourceLogo } = useOrderAssistAppFeatureFlags();

  return useMemo(() => {
    if (shouldUseDatasourceLogo) {
      return datasourcesConfig?.find((datasource) => datasource.dataSourceEnum === source)?.logo
        ?.url;
    }
    return undefined;
  }, [datasourcesConfig, source, shouldUseDatasourceLogo]);
};
